import axios from '@/lib/axios';
import { UserInvitation, Workspace } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0190. チーム登録
 * [POST] /workspaces/:identifier/teams
 */
type Props = {
  identifier: string;
  name: string;
  description: string;
  admin_user_id: number;
  approver_user_id?: number;
  backoffice_user_id?: number;
  agency_enabled: boolean;
  sales_order_menu_listed: boolean;
  purchase_order_menu_listed: boolean;
};
const createTeam = (props: Props): Promise<UserInvitation> => {
  return axios.post(`/api/workspaces/${props.identifier}/teams`, props);
};

export const useCreateTeam = () => {
  return useMutation({
    mutationFn: createTeam,
  });
};
